import conf from "./config";
import { getToken, setToken, cleanToken } from "./storage";

const auth = function () {
  if(conf.auth) return;
  conf.auth = true;
  cleanToken();
  let redirect_uri = encodeURIComponent("http://app.qihe.live/auth");
  let state = encodeURIComponent(location.href);
  let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${conf.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
  location.href = url;
};
const getSub = function (fn) {
  let temp = getToken();
  if(temp.sub == 0) {
    this.$axios({
      url: '/live/get-status'
    }).then(res => {
      if(res.code == 0) {
        temp.sub = res.subscribe;
        setToken(temp);
        typeof fn === "function" && fn(res.subscribe);
      }
    });
  } else {
    typeof fn === "function" && fn();
  }
};
export {getSub};

export default auth;
